import { render } from "./slidestc_00overview.vue?vue&type=template&id=b9e5c5e0&scoped=true"
import script from "./slidestc_00overview.vue?vue&type=script&lang=js"
export * from "./slidestc_00overview.vue?vue&type=script&lang=js"

import "@/assets/css/globalcn.css?vue&type=style&index=0&id=b9e5c5e0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e5c5e0"]])

export default __exports__